function CardsPreviewToggleModal() {
  $('#talk-to-us').on('click', function () {
    $('#cards-preview-main-content').css('display', 'none')
    $('#cards-preview-form-content').css('display', 'block')
    $('.cards-preview-arrow').css('display', 'block')
    $('.modal-icon').css('color', '#515151')
    $('.cards-preview-modal').css('background-image', 'url(/assets/images/cards/bg-fake-cards-modal-2.png)')
    $('.cards-preview-modal').css('background-size', 'cover')
  });

  $('#cards-preview-step-1').on('click', function () {
    $('#cards-preview-form-content').css('display', 'none')
    $('#cards-preview-main-content').css('display', 'block')
    $('.cards-preview-arrow').css('display', 'none')
    $('.modal-icon').css('color', '#FFFFFF')
    $('.cards-preview-modal').css('background-image', 'url(/assets/images/cards/bg-fake-cards-modal.png)')
    $('.cards-preview-modal').css('background-size', 'inherit')
  });
}

exports.init = CardsPreviewToggleModal;
